import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
type UseTextOverflowReturn = {
  ref: React.RefObject<HTMLDivElement | null>;
  isOverflowing: boolean;
};
export function useTextOverflow() {
  const $ = _c(4);
  const ref = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const container = ref.current;
      if (!container) {
        return;
      }
      const checkOverflow = () => {
        const textElement = container.querySelector("[data-marquee-inner]");
        if (textElement) {
          const scrollWidth = textElement.scrollWidth;
          const containerWidth = container.clientWidth;
          const isOverflowing_0 = scrollWidth > containerWidth;
          const overflowAmount = Math.max(0, scrollWidth - containerWidth);
          setIsOverflowing(isOverflowing_0);
          container.style.setProperty("--marquee-overflow", `${overflowAmount}px`);
        }
      };
      checkOverflow();
      const resizeObserver = new ResizeObserver(() => {
        checkOverflow();
      });
      resizeObserver.observe(container);
      return () => {
        resizeObserver.disconnect();
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== isOverflowing) {
    t2 = {
      ref,
      isOverflowing
    };
    $[2] = isOverflowing;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}